export default __webpack_public_path__ + "static/gallery01-ad767e032ecef89a95bbfc34de6097a5.png";